export default "__VITE_ASSET__BdHy2o3V__"